import $http from 'middleware/http';
import { htmlGetter, linkParser } from './util';



const FILE_NAME = 'notices.html';



export default {
  namespaced: true,

  state: {
    loaded: false,
    notices: [],
  },

  getters: {
    filepath: (state, getters, rootState, rootGetters) => rootGetters['path/$join']('conf', FILE_NAME),
    notices: (state, getters, rootState, rootGetters) => {
      const notices = state.notices.slice();
      if (getters['needShowLatestLink']) {
        notices.unshift({
          className: 'dn-top-messages__linkto-latest',
          body: '最新の大学入学共通テスト情報は<a href="{{root}}/../center/index.html">こちら</a>から！',
        });
      }
      return notices.map(notice => Object.assign({}, notice, {body: rootGetters['path/$resolve'](notice.body)}));
    },
    exist: (state, getters) => (getters['notices'].length > 0),
    needShowLatestLink: (state, getters, rootState, rootGetters) => {
      return rootGetters['path/locationIsMatchBackup'] && !rootGetters['path/locationIsMatchCmsVendor'];
    },
  },

  actions: {
    async load({ commit, getters }) {
      const res = await $http.get(getters['filepath']);
      commit('setData', res.data);
    },
  },

  mutations: {
    setData(state, html) {
      const my = this;
      const notices = [];
      const $data = $(`<div>${html}</div>`);

      const $notices = $data.find('dn-notices').children('dn-notice');
      $notices.each(function() {
        notices.push({
          body: htmlGetter($(this)),
        });
      });

      state.notices = notices;
      state.loaded = true;
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/notices.js